// src/pages/ebilling/ErrorPage.js
import { useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
    Container,
    Box,
    Typography,
    Paper,
} from '@mui/material';
import { VerifyEmailContext } from '../../auth/AuthContext';

const ErrorPage = () => {
    const location = useLocation();
    const auth = useContext(VerifyEmailContext);
    if (!auth) throw new Error('AuthContext is undefined');
    const [customerId, setCustomerId] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const customerIdParam = params.get('customerId');
        const msgErrParam = params.get('msgErr');

        if (customerIdParam) {
            setCustomerId(customerIdParam);
        }

        if (msgErrParam) {
            setErrorMessage(decodeURIComponent(msgErrParam));
        }
    }, [location.search]);

    return (
        <Container
            component="main"
            maxWidth="sm"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                p: 2,
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    borderRadius: 3,
                    width: '100%',
                    maxWidth: 450,
                    minHeight: 600,
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    overflow: 'hidden',
                    backgroundColor: 'white',
                }}
            >
                {/* Logo and Header Section */}
                <Box
                    sx={{
                        width: '100%',
                        bgcolor: 'white',
                        p: 3,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                    }}
                >
                    <Box
                        component="img"
                        src="/image/logo-header.png"
                        alt="SG CAPITAL"
                        sx={{
                            height: 60,
                            mb: 2,
                            objectFit: 'contain'
                        }}
                    />
                    <Typography
                        variant="h5"
                        component="h1"
                        sx={{
                            fontWeight: 500,
                            color: '#666666',
                            fontSize: '1.5rem'
                        }}
                    >
                        Verify Email
                    </Typography>
                </Box>

                {/* Content Section - 404 Error Display */}
                <Box
                    sx={{
                        p: 4,
                        width: '100%',
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    {/* 404 Error Number */}
                    <Typography
                        variant="h1"
                        sx={{
                            fontWeight: 400,
                            color: '#333',
                            fontSize: '4rem',
                            lineHeight: 1,
                            mb: 2,
                            textAlign: 'center'
                        }}
                    >
                        404
                    </Typography>

                    {/* Error Message */}
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 400,
                            color: '#666',
                            fontSize: '1.2rem',
                            textAlign: 'center',
                            mb: 4
                        }}
                    >
                        Page Not Found
                    </Typography>

                    {/* Additional Error Details if available */}
                    {errorMessage && (
                        <Typography
                            variant="body2"
                            sx={{
                                color: '#888',
                                fontSize: '0.9rem',
                                textAlign: 'center',
                                mb: 3,
                                maxWidth: '300px'
                            }}
                        >
                            {errorMessage}
                        </Typography>
                    )}

                    {/* Customer ID Display */}
                    {customerId && (
                        <Typography
                            variant="body2"
                            sx={{
                                color: '#999',
                                fontSize: '0.8rem',
                                textAlign: 'center',
                                mb: 4
                            }}
                        >
                            Customer ID: {customerId}
                        </Typography>
                    )}
                </Box>
            </Paper>
        </Container>
    );
};

export default ErrorPage;